import React from 'react'
import { withIcon } from '../../withIcon'

function CopyIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.14384 4.14384C4.63613 3.65156 5.30381 3.375 6 3.375H14C14.6962 3.375 15.3639 3.65156 15.8562 4.14384C16.3484 4.63613 16.625 5.30381 16.625 6V7.375H18C19.4497 7.375 20.625 8.55025 20.625 10V18C20.625 19.4497 19.4497 20.625 18 20.625H10C8.55025 20.625 7.375 19.4497 7.375 18V16.625H6C5.30381 16.625 4.63613 16.3484 4.14384 15.8562C3.65156 15.3639 3.375 14.6962 3.375 14V6C3.375 5.30381 3.65156 4.63613 4.14384 4.14384ZM8.625 18C8.625 18.7594 9.24061 19.375 10 19.375H18C18.7594 19.375 19.375 18.7594 19.375 18V10C19.375 9.24061 18.7594 8.625 18 8.625H10C9.24061 8.625 8.625 9.24061 8.625 10V18ZM15.375 7.375H10C8.55025 7.375 7.375 8.55025 7.375 10V15.375H6C5.63533 15.375 5.28559 15.2301 5.02773 14.9723C4.76987 14.7144 4.625 14.3647 4.625 14V6C4.625 5.63533 4.76987 5.28559 5.02773 5.02773C5.28559 4.76987 5.63533 4.625 6 4.625H14C14.3647 4.625 14.7144 4.76987 14.9723 5.02773C15.2301 5.28559 15.375 5.63533 15.375 6V7.375Z" fill={color}/>
    </svg>
  )
}

export default withIcon(CopyIcon)
